import React, { Component, createRef } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import * as actions from "../../actions";
import "react-phone-input-2/lib/style.css";
import "antd/dist/antd.css";
import { withRouter } from "react-router-dom";
import PropTypes from "prop-types";

import { Form, Input, Row, Col, Checkbox, Typography } from "antd";

const { Title } = Typography;

class shipperReceiverForm2 extends React.Component {
  render() {
    const {
      insuranceArr,
      previousFormData,
      dutyTax_amount_subtotal,
      totalAmount,
    } = this.props;
  
    const { getFieldDecorator } = this.props.form;

    const textStyle = {
      fontSize: "12px",
      paddingBottom: "1rem",
    };

    return (
      <div>
        <Row>
          <Title
            level={2}
            style={{ paddingBottom: "1rem", borderBottom: "2px solid black" }}
          >
            Conditions
          </Title>
          <ul style={{ listStyleType: "disc", marginLeft: "12px" }}>
            <li style={textStyle}>
              Your shipment may be delayed to a multitide of factors, including
              weather or lack of space.
            </li>
            <li style={textStyle}>
              A final approval email will be sent once the shipper has confirmed
              all shipment details, you will have the chance to reject or
              approve the final shipment then. If the shipment is rejected, you
              will not be charged.
            </li>
            <li style={textStyle}>
              Additional fees may be charged if the actual shipment quantities
              differ from the booked quantities.
            </li>
            <li style={textStyle}>
              Additional fees may be charged for items such as waiting time,
              customs or port fees.
            </li>
          </ul>
        </Row>
        <Form.Item>
          {getFieldDecorator("account_consent", {
            name: "account_consent",
            valuePropName: "checked",
            initialValue: this.props.shipperReceiverForm2?.account_consent,
            rules: [
              {
                required: false,
                message: "required",
              },
            ],
          })(
            <Checkbox //defaultChecked={true}
              onChange={this.handleChange}
            >
              Create a Prime Freight Account
            </Checkbox>
          )}
        </Form.Item>
        <Form.Item>
          {getFieldDecorator("agreement", {
            valuePropName: "checked",
            rules: [
              {
                required: true,
                message: "required",
              },
            ],
          })(
            <Checkbox>
              I Agree to{" "}
              <a href="https://www.primefreight.com/terms-and-conditions/">
                Terms and Conditions
              </a>{" "}
              and{" "}
              <a href="https://www.primefreight.com/privacy-policy/">
                Privacy Policy
              </a>
            </Checkbox>
          )}
        </Form.Item>

        <Title
          level={2}
          style={{ paddingBottom: "1rem", borderBottom: "2px solid black" }}
        >
          Payment
        </Title>
        <Row>
          <Col
            xs={24}
            sm={20}
            md={18}
            lg={16}
            xl={14}
          >
            <Form.Item label="Shipment Price">
              {getFieldDecorator("shipment_price", {
                initialValue: this.props.shipperReceiverForm2?.shipment_price,
                rules: [{ required: false, message: "required" }],
              })(<Input size="large" disabled addonBefore="$ " />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} sm={24} md={12}>
            {/* <Form.Item label="Total"> */}
            <p style={{ paddingBottom: "1rem" }}>
              Brokerage Fee:{" "}
              <span>
                {previousFormData?.custom_broker === "primeFreight"
                  ? "$ 75"
                  : 0}
              </span>
            </p>
            <p style={{ paddingBottom: "1rem" }}>
              Insurance charge:{" "}
              <span>
                {`$ ${(
                  insuranceArr?.reduce((sum, item) => {
                    return sum + Number(item?.quote?.premium_amount);
                  }, 0) || 0
                ).toFixed(2)}`}
              </span>
            </p>
            <p style={{ paddingBottom: "1rem" }}>
              Duty Fee & Tax:{" "}
              <span>{`$ ${(
                dutyTax_amount_subtotal?.duties + dutyTax_amount_subtotal?.taxes
              ).toFixed(2)}`}</span>
            </p>
            <p style={{ paddingBottom: "1rem" }}>
              Total: <span>{totalAmount}</span>
            </p>
          </Col>
        </Row>
      </div>
    );
  }
}

const WrappedShipperInfoForm2 = Form.create({ name: "shipperReceiverForm2" })(
  shipperReceiverForm2
);

shipperReceiverForm2.propTypes = {
  final_search_form: PropTypes.object,

  booking_customer_form: PropTypes.object,

  agentInformation: PropTypes.object,
};
const mapStateToProps = (state) => {
  return {
    queryParams: state.route.queryParams,
    final_search_form: state.route.final_search_form,
    agentInformation: state.form.AgentInformation,
    booking_customer_form: state.route.booking_customer_form,
  };
};

export default withRouter(
  connect(mapStateToProps, actions)(WrappedShipperInfoForm2)
);
